import React from "react";
import { Autocomplete } from "@sscs/ui";
import { TriagedFilterOption } from "../../index";
import styles from "./cveFilter.module.scss";
const CveFilter = ({ value, loading, cveList, className, onChange, onOpen, ...props }) => {
    var _a;
    return (React.createElement(Autocomplete, { id: "cve-autocomplete", className: className, options: cveList ? cveList.map((item) => item.cve) : [], isClearAlwaysVisible: Boolean(value), value: value !== null && value !== void 0 ? value : "", loading: loading, freeSolo: true, onOpen: onOpen, label: "Filter vulnerabilities by CVE identifier", inputProps: {
            maxLength: 256,
        }, onInputChange: (_event, inputValue) => {
            onChange(inputValue);
        }, renderOption: (props, option) => {
            const cve = cveList.find((item) => item.cve === option);
            return (React.createElement("li", { ...props, key: option },
                React.createElement("div", { className: styles["cve-filter-item"] },
                    React.createElement("span", null, option),
                    cve && React.createElement(TriagedFilterOption, { triaged: cve.triaged }))));
        }, "data-filtered-by-link": (_a = props["data-filtered-by-link"]) !== null && _a !== void 0 ? _a : false }));
};
export default CveFilter;
//# sourceMappingURL=CveFilter.js.map